exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview .thumbnail[data-v-17dac5e4]{height:302px;border-top-left-radius:unset;border-top-right-radius:unset}.asset-preview .thumbnail img[data-v-17dac5e4]{max-height:300px}.fa-crown.gold[data-v-17dac5e4]{color:#bf9000}", ""]);

// exports
